import { DisputeTypes } from "../../../shared/constants";
import { BackofficeDisputes } from "./disputes";

export function BackofficeBankDisputes() {
  return (
    <BackofficeDisputes disputeType={DisputeTypes.Backoffice.BankDisputes} />
  );
}
